import PageContainer from '@zenbusiness/zui/PageContainer';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const AppFooterRoot = superstyled({
  name: 'AppFooter',
  slot: 'Root',
  tag: PageContainer,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  }),
});

export const AppFooterMeta = superstyled({
  name: 'AppFooter',
  slot: 'Meta',
  tag: Text,
  propsAdded: {
    size: 'sm',
  },
  styles: ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(0.5),
  }),
});
